import React from 'react';
import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";

interface FormCheckBoxProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    label: React.ReactNode;
    error?: boolean;
}

const FormCheckBox = (props: FormCheckBoxProps) => {
    return (
        <Box>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={props.checked}
                        onChange={(e) => props.onChange(e.target.checked)}
                        sx={props.error ? { color: "error.main" } : {}}
                    />
                }
                label={
                    <Typography variant="caption" color={props.error ? "error" : "text.secondary"}>
                        {props.label}
                    </Typography>
                }
            />
        </Box>
    );
};

export default FormCheckBox;
